export const SUCCESS = 'success'
export const ERROR = 'error'
export const LOADING = 'loading'
export const NONE = 'none'

export default {
	SUCCESS, ERROR, LOADING, NONE
}
